import { Card, CardContent, CardHeader, CardTitle } from "../ui/card"
import { Users, Euro, FileCheck, TrendingUp, CalendarDays, Briefcase } from "lucide-react"

export function KPIStats({ variant = "default" }) {
  const defaultStats = [
    {
      title: "Nuovi Clienti",
      value: "+12",
      description: "Rispetto a ieri",
      icon: Users,
      trend: "+4.5%",
      trendUp: true,
      color: "text-blue-500",
      bg: "bg-blue-50",
    },
    {
      title: "Appuntamenti Oggi",
      value: "8",
      description: "3 confermati",
      icon: FileCheck,
      trend: "0%",
      trendUp: true,
      color: "text-indigo-500",
      bg: "bg-indigo-50",
    },
    {
      title: "Pratiche Chiuse",
      value: "24",
      description: "Questo mese",
      icon: TrendingUp,
      trend: "+12%",
      trendUp: true,
      color: "text-emerald-500",
      bg: "bg-emerald-50",
    },
    {
      title: "Debito Gestito",
      value: "€ 1.2M",
      description: "Totale in gestione",
      icon: Euro,
      trend: "+8%",
      trendUp: true,
      color: "text-amber-500",
      bg: "bg-amber-50",
    },
  ]

  const commercialeStats = [
    {
      title: "Nuovi Lead",
      value: "124",
      description: "Ultimi 7 giorni",
      icon: Users,
      trend: "+8.4%",
      trendUp: true,
      color: "text-orange-500",
      bg: "bg-orange-50",
    },
    {
      title: "Conversione",
      value: "32.5%",
      description: "Tasso medio campagne",
      icon: TrendingUp,
      trend: "+1.2%",
      trendUp: true,
      color: "text-emerald-500",
      bg: "bg-emerald-50",
    },
    {
      title: "Lead Attivi",
      value: "78",
      description: "In lavorazione oggi",
      icon: FileCheck,
      trend: "+3%",
      trendUp: true,
      color: "text-sky-500",
      bg: "bg-sky-50",
    },
    {
      title: "Valore Pipeline",
      value: "€ 320k",
      description: "Opportunità aperte",
      icon: Euro,
      trend: "+10%",
      trendUp: true,
      color: "text-indigo-500",
      bg: "bg-indigo-50",
    },
  ]

  const legaleStats = [
    {
      title: "Pratiche Aperte",
      value: "75",
      description: "In gestione attiva",
      icon: FileCheck,
      trend: "+5",
      trendUp: true,
      color: "text-emerald-600",
      bg: "bg-emerald-50",
    },
    {
      title: "In Scadenza 7gg",
      value: "18",
      description: "Udienze e termini",
      icon: CalendarDays,
      trend: "+3",
      trendUp: true,
      color: "text-red-500",
      bg: "bg-red-50",
    },
    {
      title: "Nuove Pratiche",
      value: "12",
      description: "Ultimi 7 giorni",
      icon: Users,
      trend: "+2",
      trendUp: true,
      color: "text-blue-500",
      bg: "bg-blue-50",
    },
    {
      title: "Success Rate",
      value: "68%",
      description: "Ultimo trimestre",
      icon: TrendingUp,
      trend: "+4%",
      trendUp: true,
      color: "text-amber-500",
      bg: "bg-amber-50",
    },
  ]

  const amministrazioneStats = [
    {
      title: "Incassi Mese",
      value: "€ 32.450",
      description: "Saldo registrato",
      icon: Euro,
      trend: "+10.5%",
      trendUp: true,
      color: "text-emerald-600",
      bg: "bg-emerald-50",
    },
    {
      title: "Insoluti Oggi",
      value: "14",
      description: "Pagamenti non andati a buon fine",
      icon: FileCheck,
      trend: "+2",
      trendUp: false,
      color: "text-red-500",
      bg: "bg-red-50",
    },
    {
      title: "Fatture Emesse",
      value: "86",
      description: "Questo mese",
      icon: Users,
      trend: "+6",
      trendUp: true,
      color: "text-blue-500",
      bg: "bg-blue-50",
    },
    {
      title: "Tasso Riscossione",
      value: "92%",
      description: "Ultimi 30 giorni",
      icon: TrendingUp,
      trend: "+3%",
      trendUp: true,
      color: "text-indigo-500",
      bg: "bg-indigo-50",
    },
  ]

  const coordinamentoStats = [
    {
      title: "Lead Assegnati",
      value: "124",
      description: "Ultimi 7 giorni",
      icon: Users,
      trend: "+5%",
      trendUp: true,
      color: "text-sky-500",
      bg: "bg-sky-50",
    },
    {
      title: "Pratiche per Dip.",
      value: "5.2",
      description: "Media per dipartimento",
      icon: FileCheck,
      trend: "+0.4",
      trendUp: true,
      color: "text-emerald-500",
      bg: "bg-emerald-50",
    },
    {
      title: "SLA Rispetto",
      value: "89%",
      description: "Task chiusi nei tempi",
      icon: TrendingUp,
      trend: "+2%",
      trendUp: true,
      color: "text-amber-500",
      bg: "bg-amber-50",
    },
    {
      title: "Attività Oggi",
      value: "48",
      description: "Task tra tutti i team",
      icon: FileCheck,
      trend: "+6",
      trendUp: true,
      color: "text-indigo-500",
      bg: "bg-indigo-50",
    },
  ]

  const hrStats = [
    {
      title: "Posizioni Aperte",
      value: "7",
      description: "Ricerca attiva",
      icon: Briefcase,
      trend: "+2",
      trendUp: true,
      color: "text-sky-500",
      bg: "bg-sky-50",
    },
    {
      title: "Colloqui Questa Settimana",
      value: "18",
      description: "Screening e tecnici",
      icon: Users,
      trend: "+4",
      trendUp: true,
      color: "text-emerald-500",
      bg: "bg-emerald-50",
    },
    {
      title: "Onboarding in Corso",
      value: "5",
      description: "Nuovi ingressi da completare",
      icon: FileCheck,
      trend: "+1",
      trendUp: true,
      color: "text-indigo-500",
      bg: "bg-indigo-50",
    },
    {
      title: "Formazioni del Mese",
      value: "3",
      description: "Sessioni programmate",
      icon: CalendarDays,
      trend: "+1",
      trendUp: true,
      color: "text-amber-500",
      bg: "bg-amber-50",
    },
  ]

  const leadStats = [
    {
      title: "Nuovi Lead",
      value: "96",
      description: "Ultimi 7 giorni",
      icon: Users,
      trend: "+6.2%",
      trendUp: true,
      color: "text-orange-500",
      bg: "bg-orange-50",
    },
    {
      title: "Tasso Qualifica",
      value: "41%",
      description: "Lead qualificati / totali",
      icon: TrendingUp,
      trend: "+1.8%",
      trendUp: true,
      color: "text-emerald-600",
      bg: "bg-emerald-50",
    },
    {
      title: "Tempo Risposta",
      value: "3.4h",
      description: "Media ultimo periodo",
      icon: CalendarDays,
      trend: "-0.6h",
      trendUp: true,
      color: "text-indigo-500",
      bg: "bg-indigo-50",
    },
    {
      title: "Lead Attivi",
      value: "52",
      description: "In lavorazione oggi",
      icon: FileCheck,
      trend: "+9%",
      trendUp: true,
      color: "text-sky-500",
      bg: "bg-sky-50",
    },
  ]

  const variants = {
    default: defaultStats,
    commerciale: commercialeStats,
    marketing: [
      {
        title: "Campagne Attive",
        value: "12",
        description: "Ultimi 30 giorni",
        icon: Briefcase,
        trend: "+2",
        trendUp: true,
        color: "text-sky-500",
        bg: "bg-sky-50",
      },
      {
        title: "CTR Medio",
        value: "2.33%",
        description: "Click-through rate",
        icon: TrendingUp,
        trend: "+0.21%",
        trendUp: true,
        color: "text-amber-500",
        bg: "bg-amber-50",
      },
      {
        title: "CPL Medio",
        value: "€ 9.80",
        description: "Costo per lead",
        icon: Euro,
        trend: "-€ 0.40",
        trendUp: true,
        color: "text-emerald-600",
        bg: "bg-emerald-50",
      },
      {
        title: "Conversioni",
        value: "3332",
        description: "Ultimi 30 giorni",
        icon: FileCheck,
        trend: "+6.1%",
        trendUp: true,
        color: "text-indigo-500",
        bg: "bg-indigo-50",
      },
    ],
    legale: legaleStats,
    amministrazione: amministrazioneStats,
    coordinamento: coordinamentoStats,
    "risorse umane": hrStats,
    hr: hrStats,
    lead: leadStats,
  }

  const normalizedVariant = variant.toLowerCase()
  const stats = variants[normalizedVariant] || variants.default

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat, index) => (
        <Card key={index} className="overflow-hidden border-none shadow-sm hover:shadow-md transition-shadow">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              {stat.title}
            </CardTitle>
            <div className={`p-2 rounded-full ${stat.bg}`}>
                <stat.icon className={`h-4 w-4 ${stat.color}`} />
            </div>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{stat.value}</div>
            <p className="text-xs text-muted-foreground mt-1">
              <span className={stat.trendUp ? "text-emerald-600 font-medium" : "text-destructive font-medium"}>
                {stat.trend}
              </span>{" "}
              {stat.description}
            </p>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
